<template>
    <settings-page :title="title" :description="description">
        <settings-presets
            :type="type"
            :element-type="elementType"
            :preview-text="previewText"
            :default-classes="defaultClasses"
            @input="onInput"
        />
    </settings-page>
</template>

<script>

import SettingsPage from '@/components/settings/shared/settings-page';
import SettingsPresets from '@/components/settings/preset/settings-presets';

export default {
    name: 'settings-presets-heading',
    components: { SettingsPage, SettingsPresets },

    data() {
        return {
            title: 'Heading Presets',
            description: 'This is where you define your heading presets. A “preset“ is a group of styles that can be be quickly added to a page element.',
            previewText: 'The quick brown fox',

            elementType: 'a-heading',
            type: 'heading',
            defaultClasses: 'f-bg-white f-text-black f-text-4 f-font-default f-leading-normal f-font-semibold',
        };
    },

    methods: {
        onInput(prop, data) {
            this.$emit('input', prop, data);
        },
    },
};
</script>
